module.exports = __webpack_public_path__ + "img/40_38_048_770.86c85909.jpg";